/* ============================================================================
   CASE HIT — storefront JS.
   · product rails from real store data · on-brand cart drawer → native checkout
   · hero carousel · quick look (with second-stage full zoom) · wishlist
   · quick add (corner buttons) · no-image products show the card name
   ============================================================================ */

function phTile(title, vendor, small) {
  return '<span class="ph-tile"><b' + (small ? ' style="font-size:9px"' : '') + '>' + title + '</b>' +
    (vendor ? '<i>' + vendor + '</i>' : '') + '</span>';
}

function gradeOf(tags) {
  for (var i = 0; i < (tags || []).length; i++) {
    if (tags[i].indexOf('grade:') === 0) return tags[i].slice(6);
  }
  return '';
}

function playerOf(tags) {
  for (var i = 0; i < (tags || []).length; i++) {
    if (tags[i].indexOf('player:') === 0) return tags[i].slice(7);
  }
  return '';
}

function money(v) {
  var n = parseFloat(v);
  return '$' + (n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
}

function cardHTML(p) {
  var title = (p.title || '').replace('[SAMPLE] ', '');
  var img = p.images && p.images.length
    ? '<img src="' + p.images[0].src + '&width=480" alt="" loading="lazy" style="width:100%;height:100%;object-fit:contain;padding:12px">'
    : phTile(playerOf(p.tags) || title, p.vendor || '');
  var grade = gradeOf(p.tags);
  var flag = grade ? '<span class="card__flag card__flag--slab">' + grade + '</span>' : '';
  var price = p.variants && p.variants.length ? money(p.variants[0].price) : '';
  return '<a class="card" href="/products/' + p.handle + '">' +
    '<div class="card__media' + (grade ? ' card__media--holo' : '') + '">' + img + flag + '</div>' +
    '<div class="card__body">' +
      '<span class="card__set">' + (p.vendor || '') + '</span>' +
      '<span class="card__name">' + title + '</span>' +
      '<div class="card__foot"><span class="card__price">' + price + '</span></div>' +
    '</div></a>';
}

function fillGrid(el, products) {
  if (!products.length) {
    var sec = el.closest('.section, .section--tight') || el;
    sec.style.display = 'none';
    return;
  }
  el.innerHTML = products.map(cardHTML).join('');
  injectCardActions();
}

function loadGrids() {
  /* ONLY placeholder strips that name their own source get filled. A bare
     `data-grid` is the collection page's real, server-rendered product grid —
     overwriting it replaced EVERY collection's products (and every filtered
     view) with the same 12 new-arrivals cards. Never widen this selector. */
  var grids = document.querySelectorAll('[data-grid="new"], [data-grid="best"]');
  if (!grids.length) return;
  var sources = {
    new: ['/collections/new-arrivals/products.json?limit=12', '/collections/all/products.json?limit=12'],
    best: ['/collections/slabs-graded/products.json?limit=8', '/collections/all/products.json?limit=8']
  };
  grids.forEach(function (el) {
    var which = el.getAttribute('data-grid') === 'best' ? 'best' : 'new';
    fetch(sources[which][0])
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.products && j.products.length) return fillGrid(el, j.products);
        return fetch(sources[which][1])
          .then(function (r) { return r.json(); })
          .then(function (j2) { fillGrid(el, (j2 && j2.products) || []); });
      })
      .catch(function () { fillGrid(el, []); });
  });
}

function wireSearch() {
  var bar = document.querySelector('[data-searchbar]');
  var input = document.querySelector('[data-search-input]');
  document.querySelectorAll('[data-search]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!bar) return;
      bar.classList.toggle('hide');
      if (!bar.classList.contains('hide') && input) input.focus();
    });
  });
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
      }
    });
  }
}

function wireReveal() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
}

function wireHeroCarousel() {
  var host = document.querySelector('[data-hero-carousel]');
  if (!host) return;
  var slides = host.querySelectorAll('.hslide');
  if (slides.length < 2) return;
  var dotsHost = host.querySelector('.hdots');
  var idx = 0, timer = null;
  slides.forEach(function (_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.setAttribute('aria-label', 'Slide ' + (i + 1));
    if (i === 0) d.className = 'on';
    d.addEventListener('click', function (e) { e.preventDefault(); go(i); restart(); });
    dotsHost.appendChild(d);
  });
  var dots = dotsHost.querySelectorAll('button');
  function go(i) {
    slides[idx].classList.remove('on'); dots[idx].classList.remove('on');
    idx = i % slides.length;
    slides[idx].classList.add('on'); dots[idx].classList.add('on');
  }
  function tick() { go(idx + 1); }
  function restart() { clearInterval(timer); timer = setInterval(tick, 3800); }
  host.addEventListener('mouseenter', function () { clearInterval(timer); });
  host.addEventListener('mouseleave', restart);
  restart();
}

var WISH_KEY = 'ch_wish';
function wishList() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
function wishSave(l) { localStorage.setItem(WISH_KEY, JSON.stringify(l)); wishBadge(); }
function wishHas(h) { return wishList().indexOf(h) !== -1; }
function wishToggle(h) {
  var l = wishList(); var i = l.indexOf(h);
  if (i === -1) l.unshift(h); else l.splice(i, 1);
  wishSave(l.slice(0, 100));
  return i === -1;
}
function wishBadge() {
  var b = document.querySelector('[data-wish-count]');
  if (!b) return;
  var n = wishList().length;
  b.hidden = n === 0;
  b.textContent = n;
}

var ql = null;
function qlEls() {
  if (!ql) ql = document.getElementById('qlook');
  return ql;
}
/* Full-screen viewer with REAL zoom: click = magnify 2.6x at that spot,
   move cursor/finger = look around the card, click again = back to full view.
   Close with ✕, the dark backdrop, or Escape. */
function openQuickLookImage(src, alt) {
  var m = qlEls(); if (!m) return;
  m.classList.add('qlook--imgonly');
  m.querySelector('[data-ql-media]').innerHTML =
    '<div class="zoomwrap"><img src="' + src + '" alt="' + (alt || '') + '" draggable="false"></div>' +
    '<div class="zoomhint">Click to zoom in</div>';
  var wrap = m.querySelector('.zoomwrap');
  var img = wrap.querySelector('img');
  var hint = m.querySelector('.zoomhint');
  var zoomed = false;
  function setOrigin(e) {
    var r = wrap.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width * 100;
    var y = (e.clientY - r.top) / r.height * 100;
    img.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
  }
  wrap.addEventListener('click', function (e) {
    zoomed = !zoomed;
    if (zoomed) setOrigin(e);
    img.style.transform = zoomed ? 'scale(2.6)' : 'none';
    wrap.classList.toggle('zoomed', zoomed);
    if (hint) hint.textContent = zoomed ? 'Move to look around · click to zoom out' : 'Click to zoom in';
  });
  wrap.addEventListener('pointermove', function (e) { if (zoomed) setOrigin(e); });
  m.hidden = false;
  document.documentElement.style.overflow = 'hidden';
}
function openQuickLook(handle) {
  var m = qlEls(); if (!m) return;
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      m.classList.remove('qlook--imgonly');
      var title = (p.title || '').replace('[SAMPLE] ', '');
      var img = p.featured_image
        ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=1200" alt="">' 
        : phTile(title, p.vendor || '');
      m.querySelector('[data-ql-media]').innerHTML = img;
      /* second-stage zoom: click the photo inside quick look for the zoomable full-screen view */
      if (p.featured_image) {
        var mi = m.querySelector('[data-ql-media] img');
        if (mi) {
          mi.style.cursor = 'zoom-in';
          mi.addEventListener('click', function () {
            openQuickLookImage(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=2048', title);
          });
        }
      }
      m.querySelector('[data-ql-vendor]').textContent = p.vendor || '';
      m.querySelector('[data-ql-title]').textContent = title;
      m.querySelector('[data-ql-price]').textContent = money(p.price / 100);
      var add = m.querySelector('[data-ql-add]');
      var v = p.variants && p.variants[0];
      if (v && p.available) {
        add.hidden = false;
        add.disabled = false;
        add.textContent = 'Add to cart';
        add.onclick = function () {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          }).then(function (r) { if (!r.ok) throw 0; closeQuickLook(); openCart(); })
            .catch(function () { window.location.href = '/products/' + handle; });
        };
      } else {
        add.hidden = false; add.disabled = true; add.textContent = 'Sold out'; add.onclick = null;
      }
      m.querySelector('[data-ql-link]').setAttribute('href', '/products/' + handle);
      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    })
    .catch(function () { window.location.href = '/products/' + handle; });
}
function closeQuickLook() {
  var m = qlEls(); if (!m) return;
  m.hidden = true;
  document.documentElement.style.overflow = '';
}
function wireQuickLook() {
  var m = qlEls(); if (!m) return;
  m.querySelectorAll('[data-ql-close]').forEach(function (b) { b.addEventListener('click', closeQuickLook); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickLook(); });
  var zoom = document.querySelector('[data-pdp-zoom]');
  if (zoom) {
    zoom.style.cursor = 'zoom-in';
    zoom.addEventListener('click', function () {
      var src = zoom.getAttribute('data-img');
      if (src) openQuickLookImage(src, zoom.getAttribute('data-alt') || '');
    });
  }
}

var EYE = '<svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 16 16"><path d="M1 8s2.7-4.5 7-4.5S15 8 15 8s-2.7 4.5-7 4.5S1 8 1 8z"/><circle cx="8" cy="8" r="2.2"/></svg>';
var HEART = '<svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 16 16"><path d="M8 13.6 3 8.6a3.3 3.3 0 0 1 4.7-4.7l.3.3.3-.3A3.3 3.3 0 0 1 13 8.6z"/></svg>';
var BAG = '<svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 16 16"><path d="M3.5 5.5h9l-.8 8h-7.4z"/><path d="M6 5.5a2 2 0 0 1 4 0"/></svg>';

function handleFromCard(card) {
  var href = card.getAttribute('href') || '';
  var mtc = href.match(/\/products\/([^\/?#]+)/);
  return mtc ? mtc[1] : null;
}

function injectCardActions() {
  document.querySelectorAll('a.card').forEach(function (card) {
    if (card.getAttribute('data-actions')) return;
    var media = card.querySelector('.card__media');
    var handle = handleFromCard(card);
    if (!media || !handle) return;
    card.setAttribute('data-actions', '1');
    var box = document.createElement('div');
    box.className = 'cact';
    box.innerHTML =
      '<button type="button" class="cact-wish' + (wishHas(handle) ? ' on' : '') + '" data-act="wish" aria-label="Wishlist">' + HEART + '</button>' +
      '<button type="button" class="cact-look" data-act="look" aria-label="Quick look">' + EYE + '</button>' +
      '<button type="button" class="cact-add" data-act="add" aria-label="Add to cart">' + BAG + '</button>';
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var act = b.getAttribute('data-act');
      if (act === 'look') openQuickLook(handle);
      else if (act === 'wish') { b.classList.toggle('on', wishToggle(handle)); }
      else if (act === 'add') {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            if (!p.available) return openQuickLook(handle);
            if (p.variants.length > 1) return openQuickLook(handle);
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
            }).then(function (r) { if (!r.ok) throw 0; openCart(); });
          })
          .catch(function () { openQuickLook(handle); });
      }
    });
    media.appendChild(box);
  });
}

var drawer = null, itemsEl = null, subEl = null;

function cartMoney(cents) { return money(cents / 100); }

function cartRowHTML(item, i) {
  var img = item.image
    ? '<img src="' + item.image + '" alt="">' 
    : phTile((item.product_title || '').replace('[SAMPLE] ', ''), '', true);
  var variantBit = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
  return '<div class="cd-row" data-line="' + (i + 1) + '">' +
    '<a class="cd-row__img" href="' + item.url + '">' + img + '</a>' +
    '<div class="cd-row__body">' +
      '<a class="cd-row__name" href="' + item.url + '">' + item.product_title.replace('[SAMPLE] ', '') + variantBit + '</a>' +
      '<div class="cd-qty">' +
        '<button type="button" data-cd-minus aria-label="Less">−</button>' +
        '<b>' + item.quantity + '</b>' +
        '<button type="button" data-cd-plus aria-label="More">+</button>' +
        '<a href="#" class="cd-remove" data-cd-remove>Remove</a>' +
      '</div>' +
    '</div>' +
    '<span class="cd-row__price">' + cartMoney(item.final_line_price) + '</span>' +
  '</div>';
}

function renderCart(cart) {
  if (!itemsEl) return;
  if (!cart.items.length) {
    itemsEl.innerHTML = '<div class="cartdrawer__empty">Your cart is empty.<br><br><a class="btn btn--primary btn--sm" href="/collections/all">Shop all cards</a></div>';
  } else {
    itemsEl.innerHTML = cart.items.map(cartRowHTML).join('');
  }
  if (subEl) subEl.textContent = cartMoney(cart.items_subtotal_price);
  var badge = document.querySelector('[data-cart-badge]');
  if (badge) badge.textContent = cart.item_count;
}

function refreshCart() {
  return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
}

function openCart() {
  if (!drawer) return (window.location.href = '/cart');
  drawer.hidden = false;
  document.documentElement.style.overflow = 'hidden';
  refreshCart();
}

function closeCart() {
  if (!drawer) return;
  drawer.hidden = true;
  document.documentElement.style.overflow = '';
}

function changeLine(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  }).then(function (r) { return r.json(); }).then(renderCart);
}

function wireCart() {
  drawer = document.getElementById('cartdrawer');
  if (!drawer) return;
  itemsEl = drawer.querySelector('[data-cart-items]');
  subEl = drawer.querySelector('[data-cart-subtotal]');

  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', closeCart);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.cd-row');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qtyEl = row.querySelector('.cd-qty b');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-cd-plus]')) changeLine(line, qty + 1);
    else if (e.target.closest('[data-cd-minus]')) changeLine(line, Math.max(0, qty - 1));
    else if (e.target.closest('[data-cd-remove]')) { e.preventDefault(); changeLine(line, 0); }
  });

  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  loadGrids();
  wireSearch();
  wireReveal();
  wireCart();
  wireQuickLook();
  wireHeroCarousel();
  injectCardActions();
  wishBadge();
});
